import script from "./TagInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TagInput.vue?vue&type=script&setup=true&lang=js"

import "./TagInput.vue?vue&type=style&index=0&id=473fe914&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473fe914"]])

export default __exports__